import { Stack, type StackProps } from '@mui/material';
import type React from 'react';

export type ModalV2ActionsProps = StackProps;

const ModalV2Actions: React.FC<ModalV2ActionsProps> = ({ children, ...props }) => {
    return (
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent='center'
            borderTop={(theme) => `1px solid ${theme.palette.divider}`}
            p={{ xs: 1, sm: 2 }}
            {...props}
        >
            {children}
        </Stack>
    );
};
export default ModalV2Actions;
